export default "__VITE_ASSET__D_6T6at7__"